import styled from 'styled-components';

export const Container = styled.div`
    width: auto !important;
    margin: -15px -10px;
    position: relative;
    padding: 15px 10px;
    height: calc(100% + 30px);
`;
